module.exports = __webpack_public_path__ + "img/code_one.9f3cf832.png";